const DATE_OPTIONS: Intl.DateTimeFormatOptions = { day: '2-digit', month: '2-digit', year: 'numeric' };
const TIME_OPTIONS: Intl.DateTimeFormatOptions = { hour: '2-digit', minute: '2-digit' };

interface DateTimeProps {
  locale: string;
  value: string;
  className?: string;
  format?: 'date-only' | 'date-time';
}

const DateTime = ({ className, format = 'date-time', locale, value }: DateTimeProps) => {
  const dateTime = format === 'date-only' ? value.split('T')[0] : value;

  if (!isValidDate(dateTime)) {
    return null;
  }

  return (
    <time className={className} dateTime={dateTime}>
      {formatDate(dateTime, locale)}
    </time>
  );
};

export default DateTime;

function isValidDate(value: string): boolean {
  return !Number.isNaN(new Date(value).getTime());
}

/**
 * A value carrying a time is a moment, shown on the reader's own clock. A value without one is a
 * date the business states — a price list was created on the 28th for every reader alike — so it is
 * read back where it was written rather than converted into anyone's timezone.
 */
export function formatDate(value: string, locale: string): string {
  const options = value.includes('T') ? { ...DATE_OPTIONS, ...TIME_OPTIONS } : { ...DATE_OPTIONS, timeZone: 'UTC' };

  return new Intl.DateTimeFormat(locale, options).format(new Date(value));
}
